import { useContext } from "react"
import Helmet from "react-helmet"

import { ThemeContext } from "../../../context/themecontext"
import InnerHTMLWithScript from "../../../components/innerhtmlwithscript/innerhtmlwithscript"
import SBEditable from "../../../components/sbEditable/sbEditable"
import { ArticlePanelOptionsToClasses } from "../articlePanelHelpers"

import styles from "./twitterembed.module.scss"

const TWITTER_SCRIPT =
  '<script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>';

function twitterembed({ blok }) {
  const theme = useContext(ThemeContext).value

  //Add the twitter script tag for tweets that don't have it
  // If it is already there helmet will remove the duplicate
  const tweetWithScript = blok.tweet + TWITTER_SCRIPT;

  return (
    <>
      <Helmet>
        {theme == "dark" ? (
          <meta name="twitter:widgets:theme" content="dark"></meta>
        ) : (
          <meta name="twitter:widgets:theme" content="light"></meta>
        )}
      </Helmet>
      <SBEditable blok={blok} withClass={ArticlePanelOptionsToClasses(blok)}>
        <div className={`div-align-${blok.alignment || "left"} ${styles.twitterWrapper}`} style={{maxWidth: blok.maxwidth ? `${blok.maxwidth}px` : 520}}>
          <InnerHTMLWithScript id={blok._uid} text={tweetWithScript} />
        </div>
      </SBEditable>
    </>
  )
}

export default twitterembed;